// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Glutathione Refill 09.17.26" (b3994eb5-72d4-4393-b845-c56daf1f7067). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiGlutathioneRefillQuestions = [
  {
    field: 'mdiGlutathioneRefill_changesMedicalHistorySinceLast',
    label:
      'Do you have any changes to your medical history since you last received this prescription?',
    type: 'select',
    educationalSlide:
      'If yes, please provide as much information as possible so your doctor can determine if your refill is safe and appropriate.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '1a111cc8-ec29-479e-928f-f2b125eac916' }
  },
  {
    field: 'mdiGlutathioneRefill_newAllergiesSinceLastPrescription',
    label:
      'Do you have any new allergies since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '860fedf8-4aa7-4b69-8ad7-fc3def637593' }
  },
  {
    field: 'mdiGlutathioneRefill_diagnosedCancerSinceLastPrescription',
    label:
      'Have you been diagnosed with cancer since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'f1d650e6-9c41-4a58-bd2a-ef19a632005e' }
  },
  {
    field: 'mdiGlutathioneRefill_diagnosedLiverKidneyDiseaseSince',
    label:
      'Have you been diagnosed with any liver or kidney disease since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'd7aa046b-47b6-4063-9ac4-2673c56675bd' }
  },
  {
    field: 'mdiGlutathioneRefill_erVisitsHospitalizationsSinceLast',
    label:
      'Have you had any ER visits or hospitalizations since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '1d0db246-578e-4cc6-8cc0-20a450261f4a' }
  },
  {
    field: 'mdiGlutathioneRefill_havingSideEffectsCurrentTreatment',
    label: 'Are you having any side effects from your current treatment?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'a980c727-422f-47f1-b299-6dbeaa545a51' }
  },
  {
    field: 'mdiGlutathioneRefill_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent form.   (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiGlutathioneRefill_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '8c379140-a7ee-4b94-b75b-f2417b800ba7' }
  },
  {
    field: 'mdiGlutathioneRefill_messageDoctorLetThemKnow',
    label:
      'This is your message to your doctor, please let them know how you are doing on your current treatment and why you want to continue on your treatment.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiGlutathioneRefill_messageDoctorLetThemKnow',
      rows: 4
    },
    extras: { mdiQuestionId: 'abaf7c4d-92a0-41c1-bbd3-82ad030ea23f' }
  },
  {
    field: 'mdiGlutathioneRefill_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiGlutathioneRefillAnswerField = Partial<
  QuestionAnswerMap<typeof mdiGlutathioneRefillQuestions>
>;

export default mdiGlutathioneRefillQuestions;
